<template>
  <div class="create-message-popup">
    <div class="form create-message-popup__content">
      <div class="form__row">
        <div class="form__input-box">
          <label class="form__label">Timing</label>
          <input
            type="text"
            :class="{'form__input': true, 'is-error': errors.has('timing')}"
            v-model="data.timing"
            v-validate="'required|integer'"
            v-input-trim
            name="timing"
          >

          <span class="form__error" v-show="errors.has('timing')">{{ errors.first('timing') }}</span>
        </div>
      </div>

      <div class="form__row">
        <div class="form__input-box">
          <label class="form__label">message</label>
          <textarea
            :class="{'form__input create-message-popup__textarea': true, 'is-error': errors.has('message')}"
            v-model="data.message"
            v-validate="'required'"
            name="message"
            v-input-trim
          ></textarea>

          <span class="form__error" v-show="errors.has('message')">{{ errors.first('message') }}</span>
        </div>
      </div>

      <div class="form__row">
        <div class="form__input-box">
          <label class="form__label">arkpromos</label>
          <input
            type="text"
            :class="{'form__input': true, 'is-error': errors.has('arkpromos')}"
            v-model="data.arkpromos"
            v-validate="'required'"
            name="arkpromos"
            v-input-trim
          >

          <span class="form__error" v-show="errors.has('arkpromos')">{{ errors.first('arkpromos') }}</span>
        </div>
      </div>

      <div class="form__row">
        <button class="ark-btn ark-btn--default" @click="toggleCreateForm(false)">
          Cancel
        </button>

        <button class="ark-btn ark-btn--danger create-message-popup__create-btn" @click="createMessage">
          <span v-if="message">Save</span>
          <span v-else>Create</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'PushNotificationMessageCreateForm',
    props: ['toggleCreateForm', 'message', 'index'],
    data () {
      return {
        data: null
      }
    },
    watch: {
      message: {
        immediate: true,
        handler (newVal, oldVal) {
          if (newVal) {
            this.data = {...newVal}
          } else {
            this.data = {}
          }
        }
      }
    },
    methods: {
      createMessage: function () {
        this.$validator.validateAll().then((isValid) => {
          if (isValid) {
            if (this.message) {
              this.$emit('pn_message_update', this.index, this.data)
            } else {
              this.$emit('pn_message_add', this.data)
            }
            this.toggleCreateForm(false)
          }
        })
      }
    }
  }
</script>
<style scoped src="./PushNotificationItemPopup.scss" lang="scss"></style>
